import React from 'react';
import { FadeIn } from './FadeIn';
export function EmpathySection() {
  return <section className="section-container" data-id="element-1">
      <FadeIn data-id="element-2">
        <h2 className="text-3xl md:text-4xl mb-8 text-center" data-id="element-3">
          If This Is You…
        </h2>

        <div className="space-y-2 text-base text-brown-800 mb-8" data-id="element-4">
          <p data-id="element-5">You open the mail.</p>
          <p data-id="element-6">
            You see{' '}
            <span className="font-bold text-red-800 bg-red-50 px-1 rounded" data-id="element-7">
              $3,800
            </span>
            . Your stomach tightens.
          </p>
          <p data-id="element-8">You think:</p>
          <p className="font-semibold text-xl text-brown-600 pl-4 border-l-4 border-terracotta-300" data-id="element-9">
            "Where is this coming from?"
          </p>
          <p data-id="element-10">You use insurance. You budget carefully. You don't overspend.</p>
          <p className="font-medium" data-id="element-11">
            So why does healthcare always feel like a financial ambush?
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-12">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-card border border-cream-200" data-id="element-13">
          <p className="text-xl font-semibold mb-6 text-center" data-id="element-14">
            Because the system understands something you don't.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-15">
            {['Margins', 'Settlement flexibility', 'Coding leverage', 'Appeal windows', 'Internal adjustment rules'].map((item, i) => <div key={i} className="flex items-center text-brown-700" data-id="element-16">
                <div className="w-2 h-2 bg-terracotta-500 rounded-full mr-3" data-id="element-17"></div>
                {item}
              </div>)}
          </div>

          <div className="bg-cream-50 p-6 rounded-xl border border-cream-100 text-center" data-id="element-18">
            <p className="text-sm uppercase tracking-widest text-brown-500 mb-2" data-id="element-19">
              That gap has a name
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-brown-900 mb-2" data-id="element-20">
              Information Asymmetry
            </h3>
            <p className="text-terracotta-600 font-medium" data-id="element-21">
              And asymmetry costs families thousands.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}